export default "__VITE_ASSET__7L5$mhrd__"